import { FunctionComponent } from 'react';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import '../css/AppHome.css';

// Riel gris azulado, tramo en cian oscuro y tirador cuadrado tinta (esquinas rectas de marca).
const CustomSlider = styled(Slider)(({ theme }) => ({
  color: 'var(--vdr-cyan-dark)',
  height: 4,
  padding: '13px 0',
  borderRadius: 0,
  '& .MuiSlider-thumb': {
    height: 16,
    width: 16,
    borderRadius: 0,
    backgroundColor: 'var(--vdr-ink)',
    border: '2px solid var(--vdr-white)',
    boxShadow: '0 0 0 1px var(--vdr-ink)',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: '0 0 0 1px var(--vdr-ink), 0 0 0 6px rgba(0, 176, 217, 0.28)'
    },
    '&:before': {
      boxShadow: 'none'
    }
  },
  '& .MuiSlider-valueLabel': {
    top: -2,
    padding: '0 2px',
    fontFamily: 'var(--vdr-font-mono)',
    fontSize: 11.5,
    fontWeight: 600,
    letterSpacing: '0.02em',
    lineHeight: 1.2,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    '&::before': {
      display: 'none'
    },
    '& *': {
      background: 'transparent',
      color: 'var(--vdr-ink)',
      ...theme.applyStyles('dark', {
        color: '#fff'
      })
    }
  },
  '& .MuiSlider-track': {
    backgroundColor: 'var(--vdr-cyan-dark)',
    border: 'none',
    borderRadius: 0,
    height: 4
  },
  '& .MuiSlider-rail': {
    backgroundColor: 'var(--vdr-line-strong)',
    opacity: 1,
    borderRadius: 0,
    height: 4
  },
  // Deshabilitado = solo lectura (p. ej. la configuración en el resultado y su PDF): mismos
  // colores de marca. El formulario de nuevo estudio lo atenúa en su propio CSS cuando está inactivo.
  '&.Mui-disabled': {
    color: 'var(--vdr-cyan-dark)',
    '& .MuiSlider-track': { backgroundColor: 'var(--vdr-cyan-dark)' },
    '& .MuiSlider-rail': { backgroundColor: 'var(--vdr-line-strong)' },
    '& .MuiSlider-thumb': {
      backgroundColor: 'var(--vdr-ink)',
      boxShadow: '0 0 0 1px var(--vdr-ink)'
    }
  },
  ...theme.applyStyles('dark', {
    color: 'var(--vdr-cyan)'
  })
}));

const MultiSlider: FunctionComponent<{
  value: number[] | number;
  onChange?: (event: Event, value: number | number[], activeThumb?: number) => void;
  disabled?: boolean;
  /** Un solo thumb 0–100 paso 10 (penetración BESS) */
  singleThumb?: boolean;
}> = ({ value, onChange, disabled, singleThumb }) => {
  if (singleThumb) {
    const v = typeof value === 'number' ? value : (value as number[])[0] ?? 0;
    return (
      <CustomSlider
        disabled={disabled}
        min={0}
        max={100}
        step={10}
        value={v}
        onChange={(e, val) =>
          onChange?.(e as unknown as Event, val as number | number[], 0)
        }
        valueLabelFormat={(n) => `${n}%`}
        valueLabelDisplay='on'
      />
    );
  }
  return (
    <CustomSlider
      disabled={disabled}
      step={10}
      value={value as number[]}
      onChange={onChange}
      valueLabelFormat={(value) => `${value}%`}
      valueLabelDisplay='on'
    />
  );
};

export default MultiSlider;
